import { useEffect, useState } from 'react'

import { getWritingHomeRedirect } from 'api/writing-profile'

type WritingHomeRedirectState = {
  redirectTo: string | null
  loading: boolean
}

export const useWritingHomeRedirect = (
  enabled: boolean
): WritingHomeRedirectState => {
  const [state, setState] = useState<WritingHomeRedirectState>({
    redirectTo: null,
    loading: enabled
  })

  useEffect(() => {
    if (!enabled) {
      setState({ redirectTo: null, loading: false })
      return
    }

    let cancelled = false
    setState({ redirectTo: null, loading: true })

    getWritingHomeRedirect()
      .then(response => {
        if (!cancelled) {
          setState({ redirectTo: response.data.redirectTo, loading: false })
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ redirectTo: null, loading: false })
        }
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return state
}
